export const coordsCheckHandler = (string: string): boolean => {
  const regExp = /^[-+]?([1-8]?\d(\.\d+)?|90(\.0+)?),\s*[-+]?(180(\.0+)?|((1[0-7]\d)|([1-9]?\d))(\.\d+)?)$/;

  return !string.match(regExp);
};
